import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from 'core/components';
import { useAgGridTableContext } from 'core/states';
import { Color, Variant } from 'theme/enums';

import { ChangeOwner } from './ChangeOwner';

interface IProps {
  onSubmitSuccess?: () => void;
}

export const ChangeOwnerButton = ({ onSubmitSuccess }: IProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const { t } = useTranslation();

  const { selectedRows } = useAgGridTableContext();

  return (
    <>
      <Button
        text={t('buttonLabelChangeOwner')}
        color={Color.PRIMARY}
        variant={Variant.OUTLINED}
        onClick={() => setIsOpen(true)}
        disabled={selectedRows.length === 0}
      />

      <ChangeOwner
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        onSubmitSuccess={onSubmitSuccess}
      />
    </>
  );
};
